import Check from "@mui/icons-material/CheckCircleOutlineOutlined";
import Close from "@mui/icons-material/CloseOutlined";
import Error from "@mui/icons-material/ErrorOutlineOutlined";
import Help from "@mui/icons-material/HelpOutlined";
import Notifications from "@mui/icons-material/NotificationsOutlined";
import {Alert, Collapse, IconButton} from "@mui/material";
import {type FC, memo, useCallback, useState} from "react";
import type {Notification} from "services/notification/types";

const ICON_MAP: Record<Notification["variant"], FC> = {
  success: Check,
  error: Error,
  warning: Help,
  info: Notifications,
};

export const NotificationAlert: FC<{
  notification: Notification;
  onClose: (id: string) => void;
}> = memo(({notification, onClose}) => {
  const [open, setOpen] = useState(true);

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => onClose(notification.id), 300);
  }, [notification.id, onClose]);

  const Icon = ICON_MAP[notification.variant];

  return (
    <Collapse in={open} timeout={300}>
      <Alert
        severity={notification.variant}
        icon={<Icon />}
        action={
          <IconButton size="small" onClick={handleClose} color="inherit">
            <Close />
          </IconButton>
        }
        sx={{mb: 1}}>
        {notification.message}
      </Alert>
    </Collapse>
  );
});
